import React from 'react';
import { Router, Switch, Route } from "react-router-dom";
import Home from "./Pages/Home/Home";
import ContactUs from "./Pages/ContactUs";
import history from './history';
import ScrollToTop from './components/ScrollToTop';

const App = (props) => {
    return (
        <>
            <Router history={history}>
                <ScrollToTop />
                <Switch>
                    <Route path="/" exact component={Home} />
                    <Route path={"/contact-us"} exact component={ContactUs} />
                </Switch>
            </Router>
        </>
    )
}

export default App;